import * as THREE from 'three';
import { BoxGeometry, ShaderChunk, SphereGeometry } from 'three';
import fragmentShader from './bgGradient.fs.glsl';
import vertexShader from './bgGradient.vs.glsl';

export default class BgGradient extends THREE.Mesh{

    constructor(){

        const material = new THREE.ShaderMaterial({
            name:'BgGradientShader',
            fragmentShader:fragmentShader,
            vertexShader:vertexShader,
            uniforms:THREE.UniformsUtils.clone(uniforms),
            side:THREE.BackSide,
        })

        super(new SphereGeometry(1), material);
    }


    setSize = (size) => {
        this.scale.setScalar(size);
    }

    setColor = (bottom, top) => {
        bottom && this.material.uniforms.uBtmColor.value.set(bottom);
        top && this.material.uniforms.uTopColor.value.set(top);
    }
}


const uniforms = {
    uBtmColor:{
        value:new THREE.Color('red'),
    },
    uTopColor:{
        value:new THREE.Color('blue'),
    }
}